import React from 'react';
import Button from "../button";
import '../../style/tobaList.css'
import CustomModal from "../General/customModal";
import TobaFormHOC from '../../containers/Tobas/tobaFormHOC';
import FormResponseMessage from "../formResponseMessage";
import FloatingIndicator from "../General/floatingIndicator";
import {TABLE_VIEW_OPTIONS, TOBA_PATH, TOBA_SHORT_TEXT} from "../../helpers/variables";
import CustomTable from "../General/customTable/CustomTable";

const columns = [
    {propertyName: "name", header: "Name"},
    {propertyName: "version", header: "Version"}
];

const TobaList = (props) => {
    const {onListItemSelect, onSelectAllItems} = props;

    return (
        <div>
            <FloatingIndicator fetching={props.tobaList.deleting}/>
            <CustomModal
                isOpen={props.tobaList.deleteModalOpen}
                content={props._getDeleteModalContent()}
                handleClose={props._closeModal}
            />
            <CustomModal
                contentClassname=''
                isOpen={props.tobaList.openTobaGroupDetailsModal}
                content={props.tobaSolicitorGroupsDetailsModalContent}
                handleClose={props._closeTobaSolicitorGroupsModal}
            />
            <CustomModal
                modelDepth={3}
                contentClassname='tobas__toba-modal'
                isOpen={props.tobaList.tobaFormModalOpen}
                content={<TobaFormHOC handleCancel={props._closeTobaFormModal} />}
                handleClose={props._closeTobaFormModal}
            />
            <div className="row">
                <h2 className="col-sm-12 applicationsAndPolicies-h2">{`${TOBA_SHORT_TEXT}s`}</h2>
            </div>
            <div className="row form-group">
                <div className="col-sm-9">
                    <Button
                        clickHandler={() => props._openTobaFormModal()}
                        btnType="button" btnStyle={'btn btn-primary btn-xs sharp white'}
                        label= {`Create New ${TOBA_SHORT_TEXT}`}
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-sm-12">
                    <CustomTable
                        onSelectedActionApply={props._handleApplyButton}
                        onSelectAction={props._handleSelectChange}
                        selectedAction={props.tobaList.selectedAction}
                        selectActions={[
                            {key: 'delete', label: 'Delete'},
                        ]}
                        onSelectAll={onSelectAllItems}
                        onDatumSelect={onListItemSelect}
                        selected={props.tobaList.selectedTobas}
                        selectable
                        accordionItemHeaderFormatter={(row) => (
                            `Name: ${row.name} Version: ${row.version}`
                        )}
                        onPageSizeChange={(evt) => {
                            props._handleStoreChange("displayAmount",evt.target.value)
                        }}
                        goAtPage={(name, value) => props._handleStoreChange(name, value)}
                        onPageShift={props._pageShift}
                        loading={props.fetchingTobas}
                        responsive
                        striped
                        columns={columns}
                        data={props.tobas}
                        pageSize={parseInt(props.tobaList.displayAmount)}
                        totalRecords={props.tobaList.totalRecords}
                        totalPages={props.tobaList.totalPaginationBoxes}
                        page={props.tobaList.page}
                        hasActions
                        actions={[
                            {
                                key: 'details',
                                label: 'View Details',
                                callback: () => null,
                                handleRedirect: (row) => (`/solicitors/${TOBA_PATH}s/`) + row.id
                            },
                            {
                                key: 'viewGroups',
                                label: 'View Groups',
                                callback: (row) => props._viewTobaSolicitorGroupsInModal(row.id)
                            },
                        ]}
                        pageSizeOptions={TABLE_VIEW_OPTIONS}
                    />
                </div>
            </div>
            <div className="row tobas__responses">
                {
                    props.tobaList.badResponseMsg?
                        <FormResponseMessage Message={props.tobaList.badResponseMsg} CenterWrapper="col-sm-12" MessageStyle="formResponseMessage-reject" />
                        :
                        null
                }
            </div>
        </div>
    )
};

export default TobaList;